import { createAsyncThunk } from '@reduxjs/toolkit';
import apiFetch from 'services/apiFetch';
import { createTimelineItem } from 'services/timelineEndPoints';
import { IAddTimeline } from 'interfaces/timeline.interface';
export const addTimeline = createAsyncThunk('timeline/add', async (data: IAddTimeline) => {
  try {
    const endpoint = createTimelineItem(data);
    return await apiFetch<Partial<IAddTimeline>>(endpoint).then((res) => res?.data || null);
  } catch (error) {
    let message = 'Something went wrong!';
    if (error instanceof Error) message = error.message;
    else {
      if (typeof error === 'object' && error !== null) {
        if ('message' in error) {
          message = String(error.message);
        }
      }
    }
    console.log('createTimeline catch:', message);
    throw Error(message);
  }
});
